import styled from 'styled-components';
import Typography from '../typography/Typography';
export const ErrMessage = styled(Typography) `
  display: flex;
  color: ${({ theme }) => theme.colors.text.critical};
`;
//# sourceMappingURL=style.js.map